(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["did-you-know-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('dyk-rotator')) return;

    class DykRotator extends HTMLElement {
      connectedCallback() {
        this.#start();
      }

      disconnectedCallback() {
        this.#stop();
      }

      #start() {
        this.#stop();
        this.timeouts = [];
        this.intervals = [];

        const autoplay = this.dataset.autoplay !== 'false';
        if (!autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const interval = Number(this.dataset.interval || 4000);
        const offset = Number(this.dataset.offset || 0);
        const slots = [...this.querySelectorAll('.dyk__slot')];

        slots.forEach((slot, index) => {
          const slides = [...slot.querySelectorAll('.dyk__slide')];
          if (slides.length < 2) return;

          const tick = () => {
            const current = slides.findIndex((slide) => slide.classList.contains('is-active'));
            const from = current < 0 ? 0 : current;
            const to = (from + 1) % slides.length;
            slides[from].classList.remove('is-active');
            slides[to].classList.add('is-active');
          };

          this.timeouts.push(
            setTimeout(() => {
              this.intervals.push(setInterval(tick, interval));
            }, offset + index * 220)
          );
        });
      }

      #stop() {
        (this.timeouts || []).forEach((id) => clearTimeout(id));
        (this.intervals || []).forEach((id) => clearInterval(id));
        this.timeouts = [];
        this.intervals = [];
      }
    }

    customElements.define('dyk-rotator', DykRotator);
  })();

  } catch(e) { console.error(e); }
})();
})();
